import {
  EnvironmentProviders,
  InjectionToken,
  makeEnvironmentProviders,
} from '@angular/core';

export enum PlanMode {
  PUPIL = 'pupil',
  INSTRUCTOR = 'instructor',
}

export interface PlanConfig {
  homiApiUrl: string;
  mode: PlanMode;
  feedback: boolean;
}

export const PLAN_CONFIG: InjectionToken<PlanConfig> =
  new InjectionToken<PlanConfig>('PLAN_CONFIG');

export function providePlan(config: PlanConfig): EnvironmentProviders {
  return makeEnvironmentProviders([{ provide: PLAN_CONFIG, useValue: config }]);
}
